/**
 * @nutrition-talent/shared-types
 * 错误码枚举 — 与 services/api/src/common/errors/error-codes.ts 同步
 */

export enum ErrorCode {
  // 认证类
  AUTH_TOKEN_MISSING = 'AUTH_TOKEN_MISSING',
  AUTH_TOKEN_INVALID = 'AUTH_TOKEN_INVALID',
  AUTH_TOKEN_EXPIRED = 'AUTH_TOKEN_EXPIRED',
  AUTH_REFRESH_FAILED = 'AUTH_REFRESH_FAILED',
  AUTH_LOGIN_FAILED = 'AUTH_LOGIN_FAILED',
  AUTH_ACCOUNT_DISABLED = 'AUTH_ACCOUNT_DISABLED',
  AUTH_ACCOUNT_NOT_FOUND = 'AUTH_ACCOUNT_NOT_FOUND',
  AUTH_WX_LOGIN_FAILED = 'AUTH_WX_LOGIN_FAILED',

  // 权限类
  TALENT_FORBIDDEN = 'TALENT_FORBIDDEN',
  COMPANY_FORBIDDEN = 'COMPANY_FORBIDDEN',
  ASSOCIATION_FORBIDDEN = 'ASSOCIATION_FORBIDDEN',
  PLATFORM_ONLY = 'PLATFORM_ONLY',
  ASSOCIATION_PRIMARY_ONLY = 'ASSOCIATION_PRIMARY_ONLY',
  DICTIONARY_READONLY = 'DICTIONARY_READONLY',

  // 资源类
  TALENT_NOT_FOUND = 'TALENT_NOT_FOUND',
  COMPANY_NOT_FOUND = 'COMPANY_NOT_FOUND',
  PROJECT_NOT_FOUND = 'PROJECT_NOT_FOUND',
  APPLICATION_NOT_FOUND = 'APPLICATION_NOT_FOUND',
  INVITATION_NOT_FOUND = 'INVITATION_NOT_FOUND',
  ASSOCIATION_NOT_FOUND = 'ASSOCIATION_NOT_FOUND',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  BANNER_NOT_FOUND = 'BANNER_NOT_FOUND',
  DICTIONARY_ITEM_NOT_FOUND = 'DICTIONARY_ITEM_NOT_FOUND',
  DICTIONARY_CATEGORY_NOT_FOUND = 'DICTIONARY_CATEGORY_NOT_FOUND',

  // 校验类
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  INVALID_PHONE = 'INVALID_PHONE',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVALID_ID_CARD = 'INVALID_ID_CARD',
  INVALID_FILE_TYPE = 'INVALID_FILE_TYPE',
  INVALID_FILE_SIZE = 'INVALID_FILE_SIZE',
  INVALID_BANNER_DIMENSION = 'INVALID_BANNER_DIMENSION',
  INVALID_BANNER_SIZE = 'INVALID_BANNER_SIZE',
  INVALID_PROJECT_DATE = 'INVALID_PROJECT_DATE',
  INVALID_PROJECT_VALIDITY = 'INVALID_PROJECT_VALIDITY',
  INVALID_COOPERATION_TYPE = 'INVALID_COOPERATION_TYPE',
  INVALID_DICTIONARY_VALUE = 'INVALID_DICTIONARY_VALUE',
  INVALID_PAGINATION = 'INVALID_PAGINATION',

  // 业务规则类
  INVITATION_REQUIRES_PROJECT = 'INVITATION_REQUIRES_PROJECT',
  INVITATION_DUPLICATE = 'INVITATION_DUPLICATE',
  APPLICATION_DUPLICATE = 'APPLICATION_DUPLICATE',
  TALENT_UNVERIFIED = 'TALENT_UNVERIFIED',
  COMPANY_UNVERIFIED = 'COMPANY_UNVERIFIED',
  PROJECT_NOT_PUBLISHED = 'PROJECT_NOT_PUBLISHED',
  PROJECT_LOCKED = 'PROJECT_LOCKED',
  PROJECT_COMPANY_LOCKED = 'PROJECT_COMPANY_LOCKED',
  PROJECT_NAME_LOCKED = 'PROJECT_NAME_LOCKED',
  ACCOUNT_ALREADY_EXISTS = 'ACCOUNT_ALREADY_EXISTS',
  BANNER_OVER_LIMIT = 'BANNER_OVER_LIMIT',
  SUB_ACCOUNT_CANNOT_CREATE_SUB = 'SUB_ACCOUNT_CANNOT_CREATE_SUB',

  // 状态机类
  INVALID_STATE_TRANSITION = 'INVALID_STATE_TRANSITION',
  TALENT_STATE_INVALID = 'TALENT_STATE_INVALID',
  COMPANY_STATE_INVALID = 'COMPANY_STATE_INVALID',
  PROJECT_STATE_INVALID = 'PROJECT_STATE_INVALID',
  APPLICATION_STATE_INVALID = 'APPLICATION_STATE_INVALID',
  INVITATION_STATE_INVALID = 'INVITATION_STATE_INVALID',
  PROJECT_EXPIRED = 'PROJECT_EXPIRED',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  BANNER_EXPIRED = 'BANNER_EXPIRED',

  // 操作日志类
  AUDIT_LOG_WRITE_FAILED = 'AUDIT_LOG_WRITE_FAILED',
  AUDIT_LOG_FORBIDDEN = 'AUDIT_LOG_FORBIDDEN',

  // 第三方依赖类
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  UPLOAD_TIMEOUT = 'UPLOAD_TIMEOUT',
  OSS_UNAVAILABLE = 'OSS_UNAVAILABLE',
  OSS_BUCKET_NOT_FOUND = 'OSS_BUCKET_NOT_FOUND',
  OSS_CORS_FAILED = 'OSS_CORS_FAILED',

  // 系统类
  SYSTEM_INTERNAL_ERROR = 'SYSTEM_INTERNAL_ERROR',
  SYSTEM_DATABASE_ERROR = 'SYSTEM_DATABASE_ERROR',
  SYSTEM_REDIS_ERROR = 'SYSTEM_REDIS_ERROR',
  SYSTEM_RATE_LIMIT = 'SYSTEM_RATE_LIMIT',
  SYSTEM_MAINTENANCE = 'SYSTEM_MAINTENANCE',
  SYSTEM_NOT_IMPLEMENTED = 'SYSTEM_NOT_IMPLEMENTED',

  // 健康隐私类(预留)
  HEALTH_DATA_FORBIDDEN = 'HEALTH_DATA_FORBIDDEN',
  PRIVACY_CONSENT_REQUIRED = 'PRIVACY_CONSENT_REQUIRED',
}

export interface ApiErrorResponse {
  code: ErrorCode | string;
  message: string;
  details?: Record<string, unknown>;
  timestamp: string;
  path: string;
  traceId?: string;
}

export interface ApiSuccessResponse<T> {
  data: T;
  meta?: {
    page?: number;
    pageSize?: number;
    total?: number;
  };
}
